<template>
	<div class="app-loading">
		<span></span>
		<span></span>
		<span></span>
	</div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.app-loading {
	display: inline-block;
	height: 40px;

	span {
		display: inline-block;
		transition: all 500ms ease;
		background: $primary;
		height: 5px;
		width: 5px;
		margin: 0 1px;
		border-radius: 10px;
		animation: wave 2s ease  infinite;

		&:nth-child(1){  animation-delay: 0; }
		&:nth-child(2){  animation-delay: 100ms; }
		&:nth-child(3){  animation-delay: 200ms; }

		@keyframes wave {
			0%, 40%, 100% {
				transform: translate(0, 0);
				background-color: $primary;
			}

			10% {
				transform: translate(0, -5px);
				background-color: lighten($primary, 12%);
			}
		}
	}
}
</style>
